// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3z6LH","text":"SelectPayment_text__rrJFQ","title":"SelectPayment_title__3jeGu","btn":"SelectPayment_btn__3Rqjj"};